import {React, useState, useEffect }from "react";
import { Routes, Route } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { FaPhoneAlt } from "react-icons/fa";
import { HelmetProvider } from 'react-helmet-async';
import WhatsAppIcon from "./utilities/WhatsAppIcon";
import { MdClose, MdKeyboardArrowDown } from "react-icons/md"
import csoverseaslogo from './assets/csoverseaslogo.png'
import ReactCountryFlag from "react-country-flag"
import Home from "./components/Home";
import BackToTopIcon from "./utilities/BackToTopIcon";
import RegistrationForm from "./utilities/RegistrationForm";
import Footer from './components/Footer'
import About from "./components/About";
import { GiHamburgerMenu } from "react-icons/gi";
import Services from './components/Services'
import Education from "./components/Education";
import IELTSPage from "./components/IELTSLearning";
import GMATPage from "./components/GMATLearning";
import GREPage from "./components/GRELearning";
import TOEFLPage from "./components/TOEFLPage";
import DuolingoPage from "./components/DuolingoLearning";
import PTEPage from "./components/PTELearning";
import Copyright from "./components/Copyright";

const App = () => {
  const navigate = useNavigate()
  const [showForm, setShowForm] = useState(false);

  const handleFormToggle = () => {
    setShowForm(!showForm);
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const [overseasMenuOpen, setOverseasMenuOpen] = useState(false);
  // const [learningPrepMenuOpen, setLearningPrepMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    if (!menuOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  };

  useEffect(() => {
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);

  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  const [isDropdown1Open, setIsDropdown1Open] = useState(false);
  const [isDropdown2Open, setIsDropdown2Open] = useState(false);

  // Improved hover handling with timeouts for smoother transitions
  const handleDropdown1Enter = () => {
    clearTimeout(dropdown1Timeout);
    setIsDropdown1Open(true);
  };

  const handleDropdown1Leave = () => {
    dropdown1Timeout = setTimeout(() => {
      setIsDropdown1Open(false);
    }, 200); // Small delay for smoother transition
  };

  const handleDropdown2Enter = () => {
    clearTimeout(dropdown2Timeout);
    setIsDropdown2Open(true);
  };

  const handleDropdown2Leave = () => {
    dropdown2Timeout = setTimeout(() => {
      setIsDropdown2Open(false);
    }, 200);
  };

  let dropdown1Timeout;
  let dropdown2Timeout;

  return (
    <HelmetProvider>
      <header className={`flex items-center justify-between p-4 bg-white shadow-md sticky top-0 z-10 transition-transform duration-300 ${isVisible ? "translate-y-0" : "-translate-y-full"}`}>
        {/* Logo */}
        <div className="flex items-center">
          <div className="flex flex-col items-start mr-2" onClick={() => navigate('/')}> 
            <div className="text-xl font-bold text-blue" style={{color:'#0F3A5E', cursor:'pointer'}}>CS Overseas</div>
            <p className="text-xs font-normal" style={{cursor:'pointer'}}>Study Abroad, Shape your Future</p> 
          </div>
          <img src={csoverseaslogo} style={{height:'50px', width:'50px', cursor:'default'}} alt="CS Overseas Logo" /> 
        </div>
        
        <nav className="relative">
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-6 text-black-700 items-center">
            {/* Overseas Education */}
            <div 
              className="relative group"
              onMouseEnter={handleDropdown1Enter}
              onMouseLeave={handleDropdown1Leave}
            >
              <p className="flex items-center cursor-pointer" style={{ color: "#0F3A5E", fontWeight: "bold" }}>
                Overseas Education
                <MdKeyboardArrowDown className={`ml-1 transition-transform ${isDropdown1Open ? "rotate-180" : ""}`} />
              </p>

              {/* Dropdown Menu */}
              <div 
                className={`absolute left-0 mt-2 bg-white shadow-lg border rounded-lg transition-all duration-200 ${isDropdown1Open ? "opacity-100 visible" : "opacity-0 invisible"}`}
                onMouseEnter={handleDropdown1Enter}
                onMouseLeave={handleDropdown1Leave}
              >
                <div className="p-4 space-y-2">
                  <a
                    href="/us"
                    className="flex items-center space-x-2 hover:text-blue-500 transition-colors duration-200"
                  >
                    <ReactCountryFlag
                      countryCode="US"
                      svg
                      style={{ width: "70px", height: "40px" }}
                    />
                    <span style={{ color: "#0F3A5E" }}>Study in USA</span>
                  </a>
                  <a
                    href="/uk"
                    className="flex items-center space-x-2 hover:text-blue-500 transition-colors duration-200"
                  >
                    <ReactCountryFlag
                      countryCode="GB"
                      svg
                      style={{ width: "70px", height: "40px" }}
                    />
                    <span style={{ color: "#0F3A5E" }}>Study in UK</span>
                  </a>
                  <a
                    href="/au"
                    className="flex items-center space-x-2 hover:text-blue-500 transition-colors duration-200"
                  >
                    <ReactCountryFlag
                      countryCode="AU"
                      svg
                      style={{ width: "70px", height: "40px" }}
                    />
                    <span style={{ color: "#0F3A5E" }}>Study in Australia</span>
                  </a>
                  <a
                    href="/eu"
                    className="flex items-center space-x-2 hover:text-blue-500 transition-colors duration-200"
                  >
                    <ReactCountryFlag
                      countryCode="EU"
                      svg
                      style={{ width: "70px", height: "40px" }}
                    />
                    <span style={{ color: "#0F3A5E" }}>Study in Europe</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Learning Prep */}
<div 
  className="relative group"
  onMouseEnter={handleDropdown2Enter}
  onMouseLeave={handleDropdown2Leave}
>
  <p className="flex items-center cursor-pointer font-bold" style={{ color: "#0F3A5E" }}>
    Learning Prep
    <MdKeyboardArrowDown className={`ml-1 transition-transform ${isDropdown2Open ? "rotate-180" : ""}`} />
  </p>
  
  <div 
    className={`absolute left-0 mt-2 w-48 bg-white shadow-lg border border-gray-100 rounded-lg transition-all duration-200 overflow-hidden ${isDropdown2Open ? "opacity-100 visible" : "opacity-0 invisible"}`}
    onMouseEnter={handleDropdown2Enter}
    onMouseLeave={handleDropdown2Leave}
  >
    <div className="flex flex-col p-2">
      <a 
        href="/ielts" 
        className="px-4 py-3 font-bold hover:bg-blue-50 transition-colors duration-200"
        style={{ color: "#0F3A5E" }}
      >
        IELTS
      </a>
      <a 
        href="/gmat" 
        className="px-4 py-3 font-bold hover:bg-blue-50 transition-colors duration-200"
        style={{ color: "#0F3A5E" }}
      >
        GMAT
      </a>
      <a 
        href="/gre" 
        className="px-4 py-3 font-bold hover:bg-blue-50 transition-colors duration-200"
        style={{ color: "#0F3A5E" }}
      >
        GRE
      </a>
      <a 
        href="/toefl" 
        className="px-4 py-3 font-bold hover:bg-blue-50 transition-colors duration-200"
        style={{ color: "#0F3A5E" }}
      >
        TOEFL
      </a>
      <a 
        href="/duolingo" 
        className="px-4 py-3 font-bold hover:bg-blue-50 transition-colors duration-200"
        style={{ color: "#0F3A5E" }}
      >
        Duolingo
      </a>
      <a 
        href="/pte" 
        className="px-4 py-3 font-bold hover:bg-blue-50 transition-colors duration-200"
        style={{ color: "#0F3A5E" }}
      >
        PTE Academic
      </a>
    </div>
  </div>
</div>

            {/* Other Links */}
            <a href="/services" className="hover:text-blue-500 transition-colors duration-200" style={{ color: "#0F3A5E", fontWeight: "bold" }}>
              Services
            </a>
            <a href="/about" className="hover:text-blue-500 transition-colors duration-200" style={{ color: "#0F3A5E", fontWeight: "bold" }}>
              About Us
            </a>
            <button onClick={handleFormToggle} className="hover:text-blue-500 transition-colors duration-200" style={{ color: "#0F3A5E", fontWeight: "bold" }}>
              Register Now
            </button>

            {/* Phone Icon */}
            <div className="relative group">
  <a href="tel:+917997222217" className="flex items-center">
    <FaPhoneAlt 
      size={20} 
      style={{ 
        marginTop: "3px", 
        color: "#0F3A5E", 
        cursor: 'pointer' 
      }} 
    />
  </a>
  <div className="absolute top-full mt-2 left-[-80%] transform translate-x-[-60%] px-3 py-1 bg-gray-700 text-white text-sm rounded shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
    +91 79972 22217
  </div>
</div>
          </div>

          {/* Mobile Menu */}
          <div className="relative">
            {/* Hamburger Icon */}
            <div className="md:hidden flex justify-between items-center z-10">
              <button className="text-gray-700 text-2xl" onClick={toggleMenu}>
                <GiHamburgerMenu />
              </button>
            </div>

            {/* Mobile Drawer */}
            <div
              className={`fixed top-0 left-0 w-full h-screen bg-white shadow-lg transform transition-transform duration-300 overflow-y-auto z-50 ${
                menuOpen ? "translate-y-0" : "-translate-y-full"
              }`}
            >
              {/* Close Button */}
              <button
                className="absolute top-4 right-4 text-gray-800 text-2xl"
                onClick={() => setMenuOpen(false)}
              >
                <MdClose />
              </button>

              {/* Menu Items */}
              <div className="flex flex-col items-center justify-center h-full text-lg font-bold space-y-6">
                <div>
                  <p
                    className="flex items-center justify-between cursor-pointer"
                    onClick={() => setOverseasMenuOpen(!overseasMenuOpen)}
                    style={{ color: "#0F3A5E" }}
                  >
                    Overseas Education
                    <MdKeyboardArrowDown
                      className={`transition-transform ${overseasMenuOpen ? "rotate-180" : ""}`}
                    />
                  </p>
                  {overseasMenuOpen && (
                    <div className="mt-2 space-y-2 text-center">
                      <a href="/us" className="block text-black hover:text-blue-500 transition-colors duration-200 flex items-center gap-2 justify-center">
                        <ReactCountryFlag countryCode="US" svg className="w-6 h-4" />
                        Study in USA
                      </a>
                      <a href="/uk" className="block text-black hover:text-blue-500 transition-colors duration-200 flex items-center gap-2 justify-center">
                        <ReactCountryFlag countryCode="GB" svg className="w-6 h-4" />
                        Study in UK
                      </a>
                      <a href="/au" className="block text-black hover:text-blue-500 transition-colors duration-200 flex items-center gap-2 justify-center">
                        <ReactCountryFlag countryCode="AU" svg className="w-6 h-4" />
                        Study in Australia
                      </a>
                      <a href="/eu" className="block text-black hover:text-blue-500 transition-colors duration-200 flex items-center gap-2 justify-center">
                        <ReactCountryFlag countryCode="EU" svg className="w-6 h-4" />
                        Study in Europe
                      </a>
                    </div>
                  )}
                </div>

                <div 
  className="relative group"
  onMouseEnter={handleDropdown2Enter}
  onMouseLeave={handleDropdown2Leave}
>
  <p className="flex items-center cursor-pointer font-bold" style={{ color: "#0F3A5E" }}>
    Learning Prep
    <MdKeyboardArrowDown className={`ml-1 transition-transform ${isDropdown2Open ? "rotate-180" : ""}`} />
  </p>
  
  <div 
    className={`absolute left-0 mt-2 w-40 bg-white shadow-lg border border-gray-100 rounded-lg transition-all duration-200 overflow-hidden ${isDropdown2Open ? "opacity-100 visible" : "opacity-0 invisible"}`}
    onMouseEnter={handleDropdown2Enter}
    onMouseLeave={handleDropdown2Leave}
  >
    <div className="flex flex-col p-1">
      <div 
        className="px-4 py-2.5 font-bold hover:bg-blue-50 transition-colors duration-200 text-center cursor-pointer"
        style={{ color: "#0F3A5E" }}
        onClick={() => window.location.href = "/ielts"}
      >
        IELTS
      </div>
      <div 
        className="px-4 py-2.5 font-bold hover:bg-blue-50 transition-colors duration-200 text-center cursor-pointer"
        style={{ color: "#0F3A5E" }}
        onClick={() => window.location.href = "/gmat"}
      >
        GMAT
      </div>
      <div 
        className="px-4 py-2.5 font-bold hover:bg-blue-50 transition-colors duration-200 text-center cursor-pointer"
        style={{ color: "#0F3A5E" }}
        onClick={() => window.location.href = "/gre"}
      >
        GRE
      </div>
      <div 
        className="px-4 py-2.5 font-bold hover:bg-blue-50 transition-colors duration-200 text-center cursor-pointer"
        style={{ color: "#0F3A5E" }}
        onClick={() => window.location.href = "/toefl"}
      >
        TOEFL
      </div>
      <div 
        className="px-4 py-2.5 font-bold hover:bg-blue-50 transition-colors duration-200 text-center cursor-pointer"
        style={{ color: "#0F3A5E" }}
        onClick={() => window.location.href = "/duolingo"}
      >
        Duolingo
      </div>
      <div 
        className="px-4 py-2.5 font-bold hover:bg-blue-50 transition-colors duration-200 text-center cursor-pointer"
        style={{ color: "#0F3A5E" }}
        onClick={() => window.location.href = "/pte"}
      >
        PTE Academic
      </div>
    </div>
  </div>
</div>

                <a href="/services" className="text-black hover:text-blue-500 transition-colors duration-200" style={{ color: "#0F3A5E" }}>Services</a>
                <a href="/about" className="text-black hover:text-blue-500 transition-colors duration-200" style={{ color: "#0F3A5E" }}>About Us</a>
                <button
                  className="text-black hover:text-blue-500 transition-colors duration-200"
                  style={{ color: "#0F3A5E" }}
                  onClick={handleFormToggle}
                >
                  Register Now
                </button>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Routes Definition */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/us" element={<Education country="USA"/>} />
        <Route path="/uk" element={<Education country="UK"/>} />
        <Route path="/au" element={<Education country="Australia"/>} />
        <Route path="/eu" element={<Education country="Europe"/>} />
        <Route path="/ielts" element={<IELTSPage/>} />
        <Route path="/gmat" element={<GMATPage/>} />
        <Route path="/gre" element={<GREPage/>} />
        <Route path="/toefl" element={<TOEFLPage/>} />
        <Route path="/duolingo" element={<DuolingoPage/>} />
        <Route path="/pte" element={<PTEPage/>} />
        <Route path="/services" element={<Services />} />
        <Route path="/copyright" element={<Copyright/>} />
        <Route path="/about" element={<About />} />
      </Routes>

      {/* Footer and Utilities */}
      <Footer />
      <BackToTopIcon />
      <WhatsAppIcon />

      {/* Registration Form Modal */}
      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-20">
          <div className="relative bg-white p-6 rounded-lg shadow-lg w-96">
            <button
              onClick={handleFormToggle}
              className="absolute top-6 right-6 text-gray-500 hover:text-gray-700 transition-colors duration-200"
            >
              &times;
            </button>
            <RegistrationForm />
          </div>
        </div>
      )}
    </HelmetProvider>
  );
};

export default App;